/**
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export class Span {

	constructor(from, to, author) {
		this.from = from
		this.to = to
		this.author = author
	}

}
